import { render, staticRenderFns } from "./AARRadd.vue?vue&type=template&id=226a0984&"
import script from "./AARRadd.vue?vue&type=script&lang=js&"
export * from "./AARRadd.vue?vue&type=script&lang=js&"
import style0 from "./AARRadd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports